import type { AppListenerMiddleware } from "@src/store/rootState";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export function setupSetEmbeddedNodesListener(
  middleware: AppListenerMiddleware
) {
  middleware.startListening({
    actionCreator: experienceBuilderSlice.actions.setEmbeddedNodes,
    effect: (_, { dispatch, getState }) => {
      const { getEmbeddedNodes, getMods } = experienceBuilderSlice.selectors;
      const { updateMods } = experienceBuilderSlice.actions;
      const nodes = getEmbeddedNodes(getState());
      const mods = getMods(getState());
      const changed: EmbeddedMod[] = [];
      for (const mod of mods) {
        if ("html" in mod && !mod.html) {
          const node = nodes[mod.selector];
          if (node) {
            changed.push({ ...mod, html: node.html });
          }
        }
      }
      if (changed.length > 0) {
        dispatch(updateMods({ set: changed }));
      }
    },
  });
}
